import { RouterManager } from '@aclass/admin/managers';
import { RedirectStory } from '@aclass/admin/storage/actions';
import { IAdminState, IRedirectModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class RedirectCreateStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:redirect-create';

    private id: string;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager,
    ) {
        super();
        this.resolver = this.ngRdx.select<IRedirectModuleState['createPageInstanceId']>(['redirectModule', 'createPageInstanceId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(RedirectCreateStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = route.params.id;
        this.ngRdx.dispatch(RedirectStory.dryRunCreatePage(this.id));
    }
}
